function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import BasePlugin from '@uppy/core/lib/BasePlugin.js';
import { nanoid } from 'nanoid/non-secure';
import { Provider, RequestClient, Socket } from '@uppy/companion-client';
import emitSocketProgress from '@uppy/utils/lib/emitSocketProgress';
import getSocketHost from '@uppy/utils/lib/getSocketHost';
import settle from '@uppy/utils/lib/settle';
import EventTracker from '@uppy/utils/lib/EventTracker';
import ProgressTimeout from '@uppy/utils/lib/ProgressTimeout';
import { RateLimitedQueue, internalRateLimitedQueue } from '@uppy/utils/lib/RateLimitedQueue';
import NetworkError from '@uppy/utils/lib/NetworkError';
import isNetworkError from '@uppy/utils/lib/isNetworkError';
var packageJson = {
  "version": "3.1.0"
};
import locale from './locale.js';

function buildResponseError(xhr, err) {
  var error = err; // No error message

  if (!error) error = new Error('Upload error'); // Got an error message string

  if (typeof error === 'string') error = new Error(error); // Got something else

  if (!(error instanceof Error)) {
    error = Object.assign(new Error('Upload error'), {
      data: error
    });
  }

  if (isNetworkError(xhr)) {
    error = new NetworkError(error, xhr);
    return error;
  }

  error.request = xhr;
  return error;
}
/**
 * Set `data.type` in the blob to `file.meta.type`,
 * because we might have detected a more accurate file type in Uppy
 * https://stackoverflow.com/a/50875615
 *
 * @param {object} file File object with `data`, `size` and `meta` properties
 * @returns {object} blob updated with the new `type` set from `file.meta.type`
 */


function setTypeInBlob(file) {
  var dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
  return dataWithUpdatedType;
}

var _queueRequestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("queueRequestSocketToken");

var _requestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("requestSocketToken");

var XHRUpload = /*#__PURE__*/function (_BasePlugin) {
  _inherits(XHRUpload, _BasePlugin);

  var _super = _createSuper(XHRUpload);

  // eslint-disable-next-line global-require
  function XHRUpload(uppy, _opts) {
    var _this2;

    _classCallCheck(this, XHRUpload);

    _this2 = _super.call(this, uppy, _opts);
    Object.defineProperty(_assertThisInitialized(_this2), _queueRequestSocketToken, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this2), _requestSocketToken, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
          var opts, Client, client, allowedMetaFields, res;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  opts = _this2.getOptions(file);
                  Client = file.remote.providerOptions.provider ? Provider : RequestClient;
                  client = new Client(_this2.uppy, file.remote.providerOptions);
                  allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields // Send along all fields by default.
                  : Object.keys(file.meta);
                  _context.next = 6;
                  return client.post(file.remote.url, _objectSpread(_objectSpread({}, file.remote.body), {}, {
                    protocol: 'multipart',
                    endpoint: opts.endpoint,
                    size: file.data.size,
                    fieldname: opts.fieldName,
                    metadata: Object.fromEntries(allowedMetaFields.map(function (name) {
                      return [name, file.meta[name]];
                    })),
                    httpMethod: opts.method,
                    useFormData: opts.formData,
                    headers: opts.headers
                  }));

                case 6:
                  res = _context.sent;
                  return _context.abrupt("return", res.token);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function value(_x) {
          return _value.apply(this, arguments);
        }

        return value;
      }()
    });
    _this2.type = 'uploader';
    _this2.id = _this2.opts.id || 'XHRUpload';
    _this2.title = 'XHRUpload';
    _this2.defaultLocale = locale; // Default options

    var defaultOptions = {
      formData: true,
      fieldName: _opts.bundle ? 'files[]' : 'file',
      method: 'post',
      allowedMetaFields: null,
      responseUrlFieldName: 'url',
      bundle: false,
      headers: {},
      timeout: 30 * 1000,
      limit: 5,
      withCredentials: false,
      responseType: '',

      /**
       * @param {string} responseText the response body string
       */
      getResponseData: function getResponseData(responseText) {
        var parsedResponse = {};

        try {
          parsedResponse = JSON.parse(responseText);
        } catch (err) {
          uppy.log(err);
        }

        return parsedResponse;
      },

      /**
       *
       * @param {string} _ the response body string
       * @param {XMLHttpRequest | respObj} response the response object (XHR or similar)
       */
      getResponseError: function getResponseError(_, response) {
        var error = new Error('Upload error');

        if (isNetworkError(response)) {
          error = new NetworkError(error, response);
        }

        return error;
      },

      /**
       * Check if the response from the upload endpoint indicates that the upload was successful.
       *
       * @param {number} status the response status code
       */
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      }
    };
    _this2.opts = _objectSpread(_objectSpread({}, defaultOptions), _opts);

    _this2.i18nInit();

    _this2.handleUpload = _this2.handleUpload.bind(_assertThisInitialized(_this2)); // Simultaneous upload limiting is shared across all uploads with this plugin.

    if (internalRateLimitedQueue in _this2.opts) {
      _this2.requests = _this2.opts[internalRateLimitedQueue];
    } else {
      _this2.requests = new RateLimitedQueue(_this2.opts.limit);
    }

    if (_this2.opts.bundle && !_this2.opts.formData) {
      throw new Error('`opts.formData` must be true when `opts.bundle` is enabled.');
    }

    if ((_opts == null ? void 0 : _opts.allowedMetaFields) === undefined && 'metaFields' in _this2.opts) {
      throw new Error('The `metaFields` option has been renamed to `allowedMetaFields`.');
    }

    _this2.uploaderEvents = Object.create(null);
    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _queueRequestSocketToken)[_queueRequestSocketToken] = _this2.requests.wrapPromiseFunction(_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _requestSocketToken)[_requestSocketToken], {
      priority: -1
    });
    return _this2;
  }

  _createClass(XHRUpload, [{
    key: "getOptions",
    value: function getOptions(file) {
      var overrides = this.uppy.getState().xhrUpload;
      var headers = this.opts.headers;

      var opts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.opts), overrides || {}), file.xhrUpload || {}), {}, {
        headers: {}
      }); // Support for `headers` as a function, only in the XHRUpload settings.
      // Options set by other plugins in Uppy state or on the files themselves are still merged in afterward.
      //
      // ```js
      // headers: (file) => ({ expires: file.meta.expires })
      // ```


      if (typeof headers === 'function') {
        opts.headers = headers(file);
      } else {
        Object.assign(opts.headers, this.opts.headers);
      }

      if (overrides) {
        Object.assign(opts.headers, overrides.headers);
      }

      if (file.xhrUpload) {
        Object.assign(opts.headers, file.xhrUpload.headers);
      }

      return opts;
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "addMetadata",
    value: function addMetadata(formData, meta, opts) {
      var allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields : Object.keys(meta); // Send along all fields by default.

      allowedMetaFields.forEach(function (item) {
        formData.append(item, meta[item]);
      });
    }
  }, {
    key: "createFormDataUpload",
    value: function createFormDataUpload(file, opts) {
      var formPost = new FormData();
      this.addMetadata(formPost, file.meta, opts);
      var dataWithUpdatedType = setTypeInBlob(file);

      if (file.name) {
        formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
      } else {
        formPost.append(opts.fieldName, dataWithUpdatedType);
      }

      return formPost;
    }
  }, {
    key: "createBundledUpload",
    value: function createBundledUpload(files, opts) {
      var _this3 = this;

      var formPost = new FormData();

      var _this$uppy$getState = this.uppy.getState(),
          meta = _this$uppy$getState.meta;

      this.addMetadata(formPost, meta, opts);
      files.forEach(function (file) {
        var options = _this3.getOptions(file);

        var dataWithUpdatedType = setTypeInBlob(file);

        if (file.name) {
          formPost.append(options.fieldName, dataWithUpdatedType, file.name);
        } else {
          formPost.append(options.fieldName, dataWithUpdatedType);
        }
      });
      return formPost;
    }
  }, {
    key: "upload",
    value: function upload(file, current, total) {
      var _this4 = this;

      var opts = this.getOptions(file);
      this.uppy.log("uploading ".concat(current, " of ").concat(total));
      return new Promise(function (resolve, reject) {
        _this4.uppy.emit('upload-started', file);

        var data = opts.formData ? _this4.createFormDataUpload(file, opts) : file.data;
        var xhr = new XMLHttpRequest();
        _this4.uploaderEvents[file.id] = new EventTracker(_this4.uppy);
        var queuedRequest;
        var timer = new ProgressTimeout(opts.timeout, function () {
          var error = new Error(_this4.i18n('uploadStalled', {
            seconds: Math.ceil(opts.timeout / 1000)
          }));

          _this4.uppy.emit('upload-stalled', error, [file]);
        });
        var id = nanoid();
        xhr.upload.addEventListener('loadstart', function () {
          _this4.uppy.log("[XHRUpload] ".concat(id, " started"));
        });
        xhr.upload.addEventListener('progress', function (ev) {
          _this4.uppy.log("[XHRUpload] ".concat(id, " progress: ").concat(ev.loaded, " / ").concat(ev.total)); // Begin checking for timeouts when progress starts, instead of loading,
          // to avoid timing out requests on browser concurrency queue


          timer.progress();

          if (ev.lengthComputable) {
            _this4.uppy.emit('upload-progress', file, {
              uploader: _this4,
              bytesUploaded: ev.loaded,
              bytesTotal: ev.total
            });
          }
        });
        xhr.addEventListener('load', function () {
          _this4.uppy.log("[XHRUpload] ".concat(id, " finished"));

          timer.done();
          queuedRequest.done();

          if (_this4.uploaderEvents[file.id]) {
            _this4.uploaderEvents[file.id].remove();

            _this4.uploaderEvents[file.id] = null;
          }

          if (opts.validateStatus(xhr.status, xhr.responseText, xhr)) {
            var _body = opts.getResponseData(xhr.responseText, xhr);

            var uploadURL = _body[opts.responseUrlFieldName];
            var uploadResp = {
              status: xhr.status,
              body: _body,
              uploadURL: uploadURL
            };

            _this4.uppy.emit('upload-success', file, uploadResp);

            if (uploadURL) {
              _this4.uppy.log("Download ".concat(file.name, " from ").concat(uploadURL));
            }

            return resolve(file);
          }

          var body = opts.getResponseData(xhr.responseText, xhr);
          var error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
          var response = {
            status: xhr.status,
            body: body
          };

          _this4.uppy.emit('upload-error', file, error, response);

          return reject(error);
        });
        xhr.addEventListener('error', function () {
          _this4.uppy.log("[XHRUpload] ".concat(id, " errored"));

          timer.done();
          queuedRequest.done();

          if (_this4.uploaderEvents[file.id]) {
            _this4.uploaderEvents[file.id].remove();

            _this4.uploaderEvents[file.id] = null;
          }

          var error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));

          _this4.uppy.emit('upload-error', file, error);

          return reject(error);
        });
        xhr.open(opts.method.toUpperCase(), opts.endpoint, true); // IE10 does not allow setting `withCredentials` and `responseType`
        // before `open()` is called.

        xhr.withCredentials = opts.withCredentials;

        if (opts.responseType !== '') {
          xhr.responseType = opts.responseType;
        }

        queuedRequest = _this4.requests.run(function () {
          _this4.uppy.emit('upload-started', file); // When using an authentication system like JWT, the bearer token goes as a header. This
          // header needs to be fresh each time the token is refreshed so computing and setting the
          // headers just before the upload starts enables this kind of authentication to work properly.
          // Otherwise, half-way through the list of uploads the token could be stale and the upload would fail.


          var currentOpts = _this4.getOptions(file);

          Object.keys(currentOpts.headers).forEach(function (header) {
            xhr.setRequestHeader(header, currentOpts.headers[header]);
          });
          xhr.send(data);
          return function () {
            timer.done();
            xhr.abort();
          };
        });

        _this4.onFileRemove(file.id, function () {
          queuedRequest.abort();
          reject(new Error('File removed'));
        });

        _this4.onCancelAll(file.id, function (_ref) {
          var reason = _ref.reason;

          if (reason === 'user') {
            queuedRequest.abort();
          }

          reject(new Error('Upload cancelled'));
        });
      });
    }
  }, {
    key: "uploadRemote",
    value: function () {
      var _uploadRemote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file) {
        var serverToken;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                this.uppy.emit('upload-started', file);

                if (!file.serverToken) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", this.connectToServerSocket(file));

              case 4:
                _context2.next = 6;
                return _classPrivateFieldLooseBase(this, _queueRequestSocketToken)[_queueRequestSocketToken](file);

              case 6:
                serverToken = _context2.sent;

                if (this.uppy.getState().files[file.id]) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", undefined);

              case 9:
                this.uppy.setFileState(file.id, {
                  serverToken: serverToken
                });
                return _context2.abrupt("return", this.connectToServerSocket(this.uppy.getFile(file.id)));

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                this.uppy.emit('upload-error', file, _context2.t0);
                throw _context2.t0;

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 13]]);
      }));

      function uploadRemote(_x2) {
        return _uploadRemote.apply(this, arguments);
      }

      return uploadRemote;
    }()
  }, {
    key: "connectToServerSocket",
    value: function connectToServerSocket(file) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        var opts = _this5.getOptions(file);

        var token = file.serverToken;
        var host = getSocketHost(file.remote.companionUrl);
        var socket;

        var createSocket = function createSocket() {
          if (socket != null) return;
          socket = new Socket({
            target: "".concat(host, "/api/").concat(token)
          });
          socket.on('progress', function (progressData) {
            return emitSocketProgress(_this5, progressData, file);
          });
          socket.on('success', function (data) {
            var body = opts.getResponseData(data.response.responseText, data.response);
            var uploadURL = body[opts.responseUrlFieldName];
            var uploadResp = {
              status: data.response.status,
              body: body,
              uploadURL: uploadURL
            };

            _this5.uppy.emit('upload-success', file, uploadResp);

            queuedRequest.done(); // eslint-disable-line no-use-before-define

            socket.close();

            if (_this5.uploaderEvents[file.id]) {
              _this5.uploaderEvents[file.id].remove();

              _this5.uploaderEvents[file.id] = null;
            }

            return resolve();
          });
          socket.on('error', function (errData) {
            var resp = errData.response;
            var error = resp ? opts.getResponseError(resp.responseText, resp) : Object.assign(new Error(errData.error.message), {
              cause: errData.error
            });

            _this5.uppy.emit('upload-error', file, error);

            queuedRequest.done(); // eslint-disable-line no-use-before-define

            if (_this5.uploaderEvents[file.id]) {
              _this5.uploaderEvents[file.id].remove();

              _this5.uploaderEvents[file.id] = null;
            }

            reject(error);
          });
        };

        _this5.uploaderEvents[file.id] = new EventTracker(_this5.uppy);

        var queuedRequest = _this5.requests.run(function () {
          if (file.isPaused) {
            var _socket;

            (_socket = socket) == null ? void 0 : _socket.send('pause', {});
          } else {
            createSocket();
          }

          return function () {
            return socket.close();
          };
        });

        _this5.onFileRemove(file.id, function () {
          var _socket2;

          (_socket2 = socket) == null ? void 0 : _socket2.send('cancel', {});
          queuedRequest.abort();
          resolve("upload ".concat(file.id, " was removed"));
        });

        _this5.onCancelAll(file.id, function (_temp) {
          var _ref2 = _temp === void 0 ? {} : _temp,
              reason = _ref2.reason;

          if (reason === 'user') {
            var _socket3;

            (_socket3 = socket) == null ? void 0 : _socket3.send('cancel', {});
            queuedRequest.abort();
          }

          resolve("upload ".concat(file.id, " was canceled"));
        });

        var onRetryRequest = function onRetryRequest() {
          if (socket == null) {
            queuedRequest.abort();
          } else {
            socket.send('pause', {});
            queuedRequest.done();
          }

          queuedRequest = _this5.requests.run(function () {
            if (!file.isPaused) {
              if (socket == null) {
                createSocket();
              } else {
                socket.send('resume', {});
              }
            }

            return function () {
              return socket.close();
            };
          });
        };

        _this5.onRetry(file.id, onRetryRequest);

        _this5.onRetryAll(file.id, onRetryRequest);
      }).catch(function (err) {
        _this5.uppy.emit('upload-error', file, err);

        return Promise.reject(err);
      });
    }
  }, {
    key: "uploadBundle",
    value: function uploadBundle(files) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        var endpoint = _this6.opts.endpoint;
        var method = _this6.opts.method;

        var optsFromState = _this6.uppy.getState().xhrUpload;

        var formData = _this6.createBundledUpload(files, _objectSpread(_objectSpread({}, _this6.opts), optsFromState || {}));

        var xhr = new XMLHttpRequest();

        var emitError = function emitError(error) {
          files.forEach(function (file) {
            _this6.uppy.emit('upload-error', file, error);
          });
        };

        var timer = new ProgressTimeout(_this6.opts.timeout, function () {
          var error = new Error(_this6.i18n('uploadStalled', {
            seconds: Math.ceil(_this6.opts.timeout / 1000)
          }));

          _this6.uppy.emit('upload-stalled', error, files);
        });
        xhr.upload.addEventListener('loadstart', function () {
          _this6.uppy.log('[XHRUpload] started uploading bundle');

          timer.progress();
        });
        xhr.upload.addEventListener('progress', function (ev) {
          timer.progress();
          if (!ev.lengthComputable) return;
          files.forEach(function (file) {
            _this6.uppy.emit('upload-progress', file, {
              uploader: _this6,
              bytesUploaded: ev.loaded / ev.total * file.size,
              bytesTotal: file.size
            });
          });
        });
        xhr.addEventListener('load', function (ev) {
          timer.done();

          if (_this6.opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
            var body = _this6.opts.getResponseData(xhr.responseText, xhr);

            var uploadResp = {
              status: ev.target.status,
              body: body
            };
            files.forEach(function (file) {
              _this6.uppy.emit('upload-success', file, uploadResp);
            });
            return resolve();
          }

          var error = _this6.opts.getResponseError(xhr.responseText, xhr) || new Error('Upload error');
          error.request = xhr;
          emitError(error);
          return reject(error);
        });
        xhr.addEventListener('error', function () {
          timer.done();
          var error = _this6.opts.getResponseError(xhr.responseText, xhr) || new Error('Upload error');
          emitError(error);
          return reject(error);
        });

        _this6.uppy.on('cancel-all', function (_temp2) {
          var _ref3 = _temp2 === void 0 ? {} : _temp2,
              reason = _ref3.reason;

          if (reason !== 'user') return;
          timer.done();
          xhr.abort();
        });

        xhr.open(method.toUpperCase(), endpoint, true); // IE10 does not allow setting `withCredentials` and `responseType`
        // before `open()` is called.

        xhr.withCredentials = _this6.opts.withCredentials;

        if (_this6.opts.responseType !== '') {
          xhr.responseType = _this6.opts.responseType;
        }

        Object.keys(_this6.opts.headers).forEach(function (header) {
          xhr.setRequestHeader(header, _this6.opts.headers[header]);
        });
        xhr.send(formData);
        files.forEach(function (file) {
          _this6.uppy.emit('upload-started', file);
        });
      });
    }
  }, {
    key: "uploadFiles",
    value: function uploadFiles(files) {
      var _this7 = this;

      var promises = files.map(function (file, i) {
        var current = parseInt(i, 10) + 1;
        var total = files.length;

        if (file.error) {
          return Promise.reject(new Error(file.error));
        }

        if (file.isRemote) {
          return _this7.uploadRemote(file, current, total);
        }

        return _this7.upload(file, current, total);
      });
      return settle(promises);
    }
  }, {
    key: "onFileRemove",
    value: function onFileRemove(fileID, cb) {
      this.uploaderEvents[fileID].on('file-removed', function (file) {
        if (fileID === file.id) cb(file.id);
      });
    }
  }, {
    key: "onRetry",
    value: function onRetry(fileID, cb) {
      this.uploaderEvents[fileID].on('upload-retry', function (targetFileID) {
        if (fileID === targetFileID) {
          cb();
        }
      });
    }
  }, {
    key: "onRetryAll",
    value: function onRetryAll(fileID, cb) {
      var _this8 = this;

      this.uploaderEvents[fileID].on('retry-all', function () {
        if (!_this8.uppy.getFile(fileID)) return;
        cb();
      });
    }
  }, {
    key: "onCancelAll",
    value: function onCancelAll(fileID, eventHandler) {
      var _this = this;

      this.uploaderEvents[fileID].on('cancel-all', function () {
        if (!_this.uppy.getFile(fileID)) return;
        eventHandler.apply(void 0, arguments);
      });
    }
  }, {
    key: "handleUpload",
    value: function handleUpload(fileIDs) {
      var _this9 = this;

      if (fileIDs.length === 0) {
        this.uppy.log('[XHRUpload] No files to upload!');
        return Promise.resolve();
      } // No limit configured by the user, and no RateLimitedQueue passed in by a "parent" plugin
      // (basically just AwsS3) using the internal symbol


      if (this.opts.limit === 0 && !this.opts[internalRateLimitedQueue]) {
        this.uppy.log('[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0', 'warning');
      }

      this.uppy.log('[XHRUpload] Uploading...');
      var files = fileIDs.map(function (fileID) {
        return _this9.uppy.getFile(fileID);
      });

      if (this.opts.bundle) {
        // if bundle: true, we don’t support remote uploads
        var isSomeFileRemote = files.some(function (file) {
          return file.isRemote;
        });

        if (isSomeFileRemote) {
          throw new Error('Can’t upload remote files when the `bundle: true` option is set');
        }

        if (typeof this.opts.headers === 'function') {
          throw new TypeError('`headers` may not be a function when the `bundle: true` option is set');
        }

        return this.uploadBundle(files);
      }

      return this.uploadFiles(files).then(function () {
        return null;
      });
    }
  }, {
    key: "install",
    value: function install() {
      if (this.opts.bundle) {
        var _this$uppy$getState2 = this.uppy.getState(),
            capabilities = _this$uppy$getState2.capabilities;

        this.uppy.setState({
          capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
            individualCancellation: false
          })
        });
      }

      this.uppy.addUploader(this.handleUpload);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      if (this.opts.bundle) {
        var _this$uppy$getState3 = this.uppy.getState(),
            capabilities = _this$uppy$getState3.capabilities;

        this.uppy.setState({
          capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
            individualCancellation: true
          })
        });
      }

      this.uppy.removeUploader(this.handleUpload);
    }
  }]);

  return XHRUpload;
}(BasePlugin);

export { XHRUpload as default };
XHRUpload.VERSION = packageJson.version;